import { render, staticRenderFns } from "./BootstrapModal.vue?vue&type=template&id=453d76ac&scoped=true&"
import script from "./BootstrapModal.vue?vue&type=script&lang=js&"
export * from "./BootstrapModal.vue?vue&type=script&lang=js&"
import style0 from "./BootstrapModal.vue?vue&type=style&index=0&id=453d76ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453d76ac",
  null
  
)

export default component.exports